module.exports = __webpack_public_path__ + "img/Logo_midi_libre.2a690fc9.png";